module.exports = __webpack_public_path__ + "img/fauteuil-16.802910a6.jpg";